import { StandProtocol } from '@/ble/entities/standProtocol'
import { FirmwareCapabilities } from '@/ble/entities/firmwareCapabilities'
import { V14_SERVICE_SHORT } from '@/ble/infrastructures/standProfile'

export type ResolveInput = {
  advertisedName: string | null
  serviceUuid: string
}

export type ResolveResult = {
  protocol: StandProtocol
  capabilities: FirmwareCapabilities
}

// platform の FirmwareCapabilities の「スイッチ報告を信頼できるか」フィールドは admin
// メンテ画面専用で消費面が無いため非移植。応答形状検出(checkIfHardwareIsPreUpdate)が効くのは
// modern(_2)系のみで、レガシーは native 同様、生のスイッチバイトをそのまま用いる。
const MODERN_CAPABILITIES: FirmwareCapabilities = {
  canDistinguishReaders: true,
}
const LEGACY_CAPABILITIES: FirmwareCapabilities = {
  canDistinguishReaders: false,
}

export class BleProtocolResolver {
  resolve(input: ResolveInput): ResolveResult {
    const { advertisedName, serviceUuid } = input

    const isV14 =
      serviceUuid.toLowerCase().includes(V14_SERVICE_SHORT) ||
      (advertisedName?.startsWith('ik_C') ?? false)

    if (isV14) {
      return { protocol: 'crc32AuthV14', capabilities: MODERN_CAPABILITIES }
    }

    const isModernAes = advertisedName?.includes('_2') ?? false
    return {
      protocol: 'aes',
      capabilities: isModernAes ? MODERN_CAPABILITIES : LEGACY_CAPABILITIES,
    }
  }
}
